
export const actions = {
  logout({}) {
    this.dispatch('taking/clear');
    if (this.$auth.loggedIn) {
      this.$auth.logout();
    }
  }
}
